import { connect } from 'react-redux';
import { cartSelector } from '../../../../redux/cart/cart.selectors';
import { Cart } from './cart';
export default connect(cartSelector, null)(Cart);